module.exports = "<modal #modalViewChild >\n  <modal-header [show-close]=\"true\"></modal-header>\n  <modal-body>\n    <div #playerContainer>\n    </div>\n  </modal-body>\n</modal>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mprep/shared/lib/angular/components/flowplayer/renderers/modal/flowplayer-modal-renderer.html
// module id = J4Qe
// module chunks = 3